import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleTop50() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-spreadsheet-top-50-produktow")!;
  return <ArticleLayout article={article} />;
}